<div class="graph-controls">
  <app-selectbox
    [options]="periodOptions"
    [ngModel]="selectedPeriod"
    (onChanged)="handlePeriodChange($event)"
    [label]="'Graph type'"
  ></app-selectbox>


  @switch (period) {
    @case ('trailing') {
      <app-selectbox
      [options]="dayOptions"
      [ngModel]="selectedDays"
      (onChanged)="handleDaysChange($event)"
      [label]="'Range'"
    ></app-selectbox>
    }
    @case ('day') {
      <app-selectbox
      [options]="monthOptions"
      [ngModel]="selectedMonth"
      (onChanged)="handleMonthChange($event)"
      [label]="'Month'"
    ></app-selectbox>
        <app-selectbox
        [options]="yearOptions"
        [ngModel]="selectedYear"
        (onChanged)="handleYearChange($event)"
        [label]="'Year'"
      ></app-selectbox>
    }
    @case ('week') {
      <app-selectbox
      [options]="weekOptions"
      [ngModel]="selectedWeek"
      (onChanged)="handleWeekChange($event)"
      [label]="'Week'"
    ></app-selectbox>
    }
    @case ('month') {
      <app-selectbox
      [options]="monthSpanOptions"
      [ngModel]="selectedMonthSpan"
      (onChanged)="handleMonthSpanChange($event)"
      [label]="'Range'"
    ></app-selectbox>
    }
  }

  <app-selectbox
    [options]="maxListOptions"
    [ngModel]="selectedMaxList"
    (onChanged)="handleMaxListChange($event)"
    [label]="'List transactions when'"
  ></app-selectbox>

<div class="graph-surface" [showLoadingSpinner]="loading">
  <app-dual-axis-chart
    [values]="rows"
    [property1]="'total_volume'"
    [property2]="'txn_count'"
    [xLabelProperty]="'time_period'"
    [reversalsProperty]="'total_reversals'"
    [p25Property]="'p25'"
    [medianProperty]="'median'"
    [p75Property]="'p75'"
    [transactionsProperty]="'transactions'"
    [label1]="'Volume'"
    [label2]="'Transactions'"
    [reversalsLabel]="'Returns'"
    [fullDates]="fullDates"
    [ratio]="chartRatio"
    [format1]="currency"
    [format2]="count"
  ></app-dual-axis-chart>
</div>